import { CustomModalLayoutProps } from '@wix/design-system';
import { ReactNode } from 'react';

export type CustomModalContent<T> = (props: {
  isOpen: boolean;
  close: (items?: T[]) => Promise<unknown>;
  width?: CustomModalLayoutProps['width'];
}) => ReactNode;
